/* eslint @typescript-eslint/no-explicit-any: 0 */
import {AxiosInstance, AxiosResponse, Method} from 'axios';
import RootStore from '../Core/mobx/RootStore';
import MockAdapter from 'axios-mock-adapter';
import setupMocks from './mocks';

const handleError = (e: unknown) => {
    // eslint-disable-next-line no-console
    console.error('Received error', e);

    if (typeof e === 'object') {
        const obj = e as {response?: {data?: {error?: object | string}}};

        if (typeof obj.response?.data?.error === 'object') {
            RootStore.uiStore.showSnackbar('Something went wrong', 'error');
        }
        if (typeof obj.response?.data?.error === 'string') {
            RootStore.uiStore.showSnackbar(obj.response?.data?.error, 'error');
        }
    } else {
        RootStore.uiStore.showSnackbar('Something went wrong', 'error');
    }
};

const requestHelper = async <T = object>(
    data: any | null,
    url: string,
    Instance: AxiosInstance,
    method: Method,
    uploadProgressCallback?: (progress: number) => void,
    params?: Record<string, unknown>,
    returnFullResponse = false,
    headers?: Record<string, string>,
): Promise<T | AxiosResponse<T> | null> => {
    const onUploadProgress = (progressEvent: any) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);

        uploadProgressCallback?.(percentCompleted);
    };
    const config = data ? {method, url, data, onUploadProgress, headers} : {method, url, params, headers};

    try {
        if (process.env.NEXT_PUBLIC_SST_STAGE === 'e2e') {
            const mockedInstance = new MockAdapter(Instance);
            setupMocks(mockedInstance);
            const response = await Instance.request(config);
            return response.data.mocked;
        }

        const response = await Instance.request(config);

        if (returnFullResponse) {
            return response;
        }

        return response.data;
    } catch (e) {
        handleError(e);
        return null;
    }
};

export default requestHelper;
